import { cn } from 'lib/utils';

/** A usage bar. Any use shows a sliver, and the bar turns amber from 80% or when warned. */
export function UsageBar({
  percent,
  warn = false,
  calm = false,
  danger = false,
}: {
  percent: number;
  warn?: boolean;
  /** Never amber: the limit is full but top-up credits cover the use. */
  calm?: boolean;
  /** Red: the limit is used up. */
  danger?: boolean;
}) {
  const width = Math.min(100, Math.max(percent, percent > 0 ? 1.5 : 0));

  const getColor = () => {
    if (danger) return 'bg-error-700';
    if (!calm && (warn || percent >= 80)) return 'bg-warning-high-emphasis';
    return 'bg-foreground/70';
  };

  return (
    <div className="h-1.5 w-full overflow-hidden rounded-full bg-muted">
      <div
        className={cn('h-full rounded-full transition-[width]', getColor())}
        style={{ width: `${width}%` }}
      />
    </div>
  );
}
